export interface HighlightSegment {
  text: string;
  match: boolean;
}

const foldChar = (char: string): string => {
  const folded = char.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  return folded[0] ?? char;
};

const foldTerm = (value: string): string => [...value].map(foldChar).join('');

export function splitHighlight(text: string, query: string): HighlightSegment[] {
  if (!text) return [];

  const terms = foldTerm(query).trim().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return [{ text, match: false }];

  const chars = [...text];
  const haystack = chars.map(foldChar).join('');
  const marks = new Array<boolean>(chars.length).fill(false);

  for (const term of terms) {
    let index = haystack.indexOf(term);
    while (index > -1) {
      for (let position = index; position < index + term.length; position++) {
        marks[position] = true;
      }
      index = haystack.indexOf(term, index + 1);
    }
  }

  const segments: HighlightSegment[] = [];
  for (let position = 0; position < chars.length; position++) {
    const previous = segments[segments.length - 1];
    if (previous && previous.match === marks[position]) {
      previous.text += chars[position];
    } else {
      segments.push({ text: chars[position], match: marks[position] });
    }
  }

  return segments;
}
